import * as contractorApi from '@/api/projectContractor/request'
import lodash from 'lodash'
import types from '@/store/mutation-types'
import { getAccountById } from '@/api/accounts/request'
import { updateVueObject } from '@/store/util'
import { CONTRACTOR_TYPES } from '@/modules/tenantProjects/contractors/consts'
import { MAX_STRING } from '@/utils/locale'

const defaultState = getDefaultState()

function getDefaultState () {
  return {
    mainContractor: {},
    contractors: [],
    isTms: false,
    vendorUsers: [],
  }
}

function sortSubContractors (contractors) {
  return lodash.orderBy(contractors,
    [(contractor) => (contractor.type === CONTRACTOR_TYPES.OTHER ? MAX_STRING : contractor.type),
      (contractor) => deep(contractor, 'company.name')])
}

// getters
const getters = {
  currentMainContractor: state => state.mainContractor,
  currentContractors: state => state.contractors,
  currentVendorUsers: state => state.vendorUsers,
  isTms: state => state.isTms,
  isMainUser (state, getters, rootState, rootGetters) {
    const user = rootGetters['user/currentUser'] || {}
    return lodash.get(state.mainContractor, 'primaryContact.userId') === user.id
  },
  isSubUser (state, getters, rootState, rootGetters) {
    const user = rootGetters['user/currentUser'] || {}
    return state.contractors.some(item => lodash.get(item, 'primaryContact.userId') === user.id)
  },
  isCurrentVendorAccount (state, getters, rootState, rootGetters) {
    const user = rootGetters['user/currentUser'] || {}
    return state.vendorUsers.some(item => item.id === user.id)
  },
  myContractor (state, getters, rootState, rootGetters) {
    const user = rootGetters['user/currentUser'] || {}
    const isMainUser = getters['isMainUser'] || false
    const isSubUser = getters['isSubUser'] || false
    if (isMainUser) return state.mainContractor
    if (isSubUser) {
      return state.contractors.find(contractor => {
        const userId = lodash.get(contractor, 'primaryContact.userId')
        return (userId === user.id)
      })
    }
    return ''
  },
}

// mutations
const mutations = {
  [types.PROJECT_CONTRACTOR_LOAD_CURRENT] (state, { mainContractor, contractors, isTms }) {
    if (mainContractor) {
      state.mainContractor = mainContractor
    }
    state.contractors = sortSubContractors(contractors || [])
    if (typeof isTms !== 'undefined') {
      state.isTms = isTms
    }
  },
  [types.UPDATE_PATH_FIELD] (state, { path, newValue }) {
    updateVueObject(state, path, newValue)
  },
  [types.RESET_STATE] (state) {
    state.mainContractor = {}
    state.contractors = []
  },
  [types.SET_VENDOR_USERS] (state, users) {
    if (users.length) {
      state.vendorUsers = users
    }
  },
}

const actions = {
  async getProjectContractors ({commit}, projectId) {
    if (projectId) {
      const projectContractor = await contractorApi.getContractors(projectId)
      if (projectContractor) {
        commit(types.PROJECT_CONTRACTOR_LOAD_CURRENT, projectContractor)
      }
    }
  },

  async getVendorUserList ({commit}, companyId) {
    if (companyId) {
      const company = await getAccountById(companyId)
      if (company.users.length) {
        commit(types.SET_VENDOR_USERS, company.users)
      }
    }
  },

  async updateProjectContractors ({state, dispatch, rootGetters}, {isTenantProject}) {
    let projectId
    const request = {
      mainContractor: state.mainContractor,
      contractors: state.contractors,
    }
    request.contractors.forEach(contractor => {
      if (contractor.type !== CONTRACTOR_TYPES.OTHER && contractor.typeDesc) {
        contractor.typeDesc = null
      }
    })
    if (isTenantProject) {
      projectId = rootGetters['tenantProject/currentTenantProject'].id
    } else {
      projectId = rootGetters['projects/currentProject'].id
    }
    await contractorApi.updateContractors(projectId, request, isTenantProject)
  },

  setContractors ({ commit }, { project = {}, needRoot = false, isTms = false }) {
    const type = needRoot ? `projectContractors/${types.PROJECT_CONTRACTOR_LOAD_CURRENT}` : types.PROJECT_CONTRACTOR_LOAD_CURRENT
    project.mainContractor = project.mainContractor || {}
    commit(type, { ...project, isTms }, needRoot ? { root: true } : '')
  },
}

export default {
  namespaced: true,
  state: defaultState,
  getters,
  actions,
  mutations,
}
